import { Map } from 'immutable';
import actions from './actions';

const initialState = new Map({
  // rentVerifications
  rentVerifications: false,
  gettingRentVerifications: false,
  gettingRentVerificationsFailed: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    // DO_GET_RENT_VERIFICATIONS
    case actions.DO_GET_RENT_VERIFICATIONS:
      return state
        .set('rentVerifications', false)
        .set('gettingRentVerifications', true)
        .set('gettingRentVerificationsFailed', null)
    case actions.DO_GET_RENT_VERIFICATIONS_SUCCESS:
      return state
        .set('rentVerifications', action.payload)
        .set('gettingRentVerifications', false)
        .set('gettingRentVerificationsFailed', null)
    case actions.DO_GET_RENT_VERIFICATIONS_FAILED:
      return state
        .set('rentVerifications', false)
        .set('gettingRentVerifications', false)
        .set('gettingRentVerificationsFailed', action.payload)
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/outstandingRentVerifications/reducer.js